import React, { useState } from 'react';
import PrimaryNavBar from 'components/ui/PrimaryNavBar';
import Icon from 'components/AppIcon';
import GettingStartedTab from './components/GettingStartedTab';
import UserGuideTab from './components/UserGuideTab';
import FormulaReferenceTab from './components/FormulaReferenceTab';
import KeyboardShortcutsTab from './components/KeyboardShortcutsTab';
import SupportFeedbackTab from './components/SupportFeedbackTab';

const TABS = [
  { id: 'getting-started', label: 'Primeros pasos', shortLabel: 'Inicio', icon: 'Rocket' },
  { id: 'user-guide', label: 'Guia de usuario', shortLabel: 'Guia', icon: 'BookOpen' },
  { id: 'formulas', label: 'Referencia de formulas', shortLabel: 'Formulas', icon: 'Function' },
  { id: 'shortcuts', label: 'Atajos de teclado', shortLabel: 'Atajos', icon: 'Keyboard' },
  { id: 'support', label: 'Soporte y feedback', shortLabel: 'Soporte', icon: 'LifeBuoy' },
];

export default function Help() {
  const [activeTab, setActiveTab] = useState('getting-started');

  const renderTab = () => {
    switch (activeTab) {
      case 'getting-started': return <GettingStartedTab />;
      case 'user-guide': return <UserGuideTab />;
      case 'formulas': return <FormulaReferenceTab />;
      case 'shortcuts': return <KeyboardShortcutsTab />;
      case 'support': return <SupportFeedbackTab />;
      default: return <GettingStartedTab />;
    }
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-background)' }}>
      <PrimaryNavBar />
      <main style={{ paddingTop: '60px' }}>
        <div className="border-b" style={{ background: 'var(--color-card)', borderColor: 'var(--color-border)' }}>
          <div className="max-w-5xl mx-auto px-4 lg:px-6 py-6">
            <div className="flex items-center gap-3 mb-1">
              <div
                className="flex items-center justify-center rounded-lg"
                style={{ width: 36, height: 36, background: 'color-mix(in srgb, var(--color-accent) 12%, transparent)' }}
              >
                <Icon name="HelpCircle" size={20} color="var(--color-accent)" strokeWidth={2} />
              </div>
              <h1 className="font-bold text-foreground" style={{ fontSize: '1.375rem', fontFamily: 'var(--font-heading)', letterSpacing: '-0.02em' }}>
                Centro de Ayuda
              </h1>
            </div>
            <p className="text-muted-foreground ml-12" style={{ fontSize: '0.9rem', fontFamily: '"IBM Plex Sans", sans-serif' }}>
              Documentacion, formulas, atajos y soporte para MetalRecovery
            </p>
          </div>

          <div className="max-w-5xl mx-auto px-4 lg:px-6">
            <nav className="flex gap-0 overflow-x-auto" style={{ scrollbarWidth: 'none' }} aria-label="Secciones de ayuda">
              {TABS?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-standard relative ${
                    activeTab === tab?.id
                      ? 'text-accent border-accent' :'text-muted-foreground border-transparent hover:text-foreground hover:border-border'
                  }`}
                  style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.875rem' }}
                  aria-current={activeTab === tab?.id ? 'page' : undefined}
                >
                  <Icon name={tab?.icon} size={15} color="currentColor" strokeWidth={activeTab === tab?.id ? 2.5 : 2} />
                  <span className="hidden sm:inline">{tab?.label}</span>
                  <span className="sm:hidden">{tab?.shortLabel}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-4 lg:px-6 py-8">
          {renderTab()}
        </div>
      </main>
    </div>
  );
}
